import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoFoetex = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 177 130",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 174,
		height: 125,
		x: 1.5,
		y: 1.5,
		fill: "var(--background-color, #0F223B)",
		stroke: "var(--border-color, #0F223B)",
		strokeWidth: 3,
		rx: 43.5
	}), /* @__PURE__ */ _jsx("path", {
		fill: "var(--font-color, white)",
		fillRule: "evenodd",
		d: "M147.888 84.803h10.933l-5.981-17.046 5.981-16.996h-10.933l-3.425 9.644-3.412-9.644h-10.932l5.97 16.996-5.97 17.045h10.932l3.412-9.934zm-35.779-14.637h14.077V59.494c0-4.797-3.932-8.733-8.703-8.733h-7.184c-4.775 0-8.718 3.935-8.718 8.733v16.581c0 4.79 3.943 8.727 8.718 8.727h7.184c4.771 0 8.703-3.937 8.703-8.727v-3.084h-10.349v4.21c0 1.038-.876 1.952-1.871 1.952h-.045c-.991 0-1.812-.914-1.812-1.952zm-21.624-13.43h6.49V50.76h-6.49V36.297h-1.087s-.391 1.3-3.707 3.583c-3.275 2.285-6.216 1.651-6.216 1.651v9.23h-5.903v5.974h5.903v19.34c0 4.79 3.936 8.727 8.734 8.727h8.765v-5.305h-4.672s-.856-.454-1.298-.788c-.45-.34-.519-1.436-.519-1.436zM61.502 84.801c4.818 0 8.73-3.93 8.73-8.727V59.473c0-4.817-3.912-8.712-8.73-8.712h-7.157c-4.809 0-8.72 3.895-8.72 8.712v16.602c0 4.797 3.911 8.727 8.72 8.727zM36.02 42.544h5.692v-7.002H27.037s-1.145 0-2.303 1.622c-1.118 1.521-1.118 4.592-1.118 4.592v9.005h-8.032v6.003h8.032v28.038h11.096V56.765h7v-6.003h-7v-6.835s0-.61.504-1.032c.515-.403.804-.35.804-.35m77.844 13.793h.044c.996 0 1.81.896 1.81 1.95v5.983h-3.721v-5.983c0-1.054.889-1.95 1.867-1.95M55.977 77.23c0 1.05.822 1.947 1.793 1.947h.03c1.002 0 1.881-.897 1.881-1.947v-9.028l-3.704 7.874zm1.864-20.864h.045c.981 0 1.795.894 1.795 1.93v1.178l-3.704 7.88v-9.058c0-1.036.883-1.93 1.864-1.93",
		clipRule: "evenodd"
	})]
});
export default SvgLogoFoetex;
